export default {
    acceptdButton: 'Aceitar',
    rejectButton: 'Recusar',
    termsAndConditionsLabel: 'Li e aceito os termos e condições',
}